import React from "react";
import styled from "styled-components";

import Error from "../components/Error";
import Filters from "../components/Filters";
import Loading from "../components/Loading";
import ProductIndex from "../components/ProductIndex";
import ProductList from "../components/ProductList";
import { useProductsContext } from "../context/ProductsContext";

const ProductsPageAll = (props: any) => {
  const { filter } = props;

  const { productsLoading, productsError, products } = useProductsContext();
  if (productsLoading) {
    return <Loading />;
  }
  if (productsError) {
    return <Error />;
  }

  const filteredProducts = filter
    ? products.filter((product) => product.category === filter)
    : products;

  return (
    <main>
      <ProductIndex
        title={filter ? filter : "New Releases"}
        number={filteredProducts.length}
      />
      <Wrapper className="page">
        <div className="section-center products">
          <Filters showColor filter={filter} />
          <div>
            <ProductList filter={filter} products={filteredProducts} />
          </div>
        </div>
      </Wrapper>
    </main>
  );
};

const Wrapper = styled.div`
  .products {
    display: grid;
    gap: 3rem 1.5rem;
    margin: 1rem auto;
  }
  @media (min-width: 550px) {
    .products {
      grid-template-columns: 200px 1fr;
    }
  }
`;

export default ProductsPageAll;
